// src/pages/Contato.jsx
import React from 'react';
import { Link } from 'react-router-dom';

import './Contato.css';

const deviceIsMobile = () => {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

// Retorna a URL base do WhatsApp, dependendo se é mobile ou desktop
const whatsappURL = () => {
  const number = '5544991046020';
  return deviceIsMobile()
    ? `https://wa.me/${number}`
    : `https://web.whatsapp.com/send?phone=${number}`;
};

// Monta o texto da mensagem de forma amigável e lida com campos vazios
function getMessageText() {
  const form = document.forms['contact-form'];
  const nome = form.elements['nome'].value.trim();
  const email = form.elements['email'].value.trim();
  const celular = form.elements['celular'].value.trim();
  const instituicao = form.elements['instituicao'].value.trim();
  const cargo = form.elements['cargo'].value.trim();
  const mensagem = form.elements['mensagem'].value.trim();

  const lines = [];
  lines.push('Olá, tudo bem?' + (nome? ` Meu nome é *${nome}*.` : ''));
  lines.push('Estou entrando em contato a partir do site de vocês. Gostaria de saber mais sobre a Plataforma CODI.');

  // Montamos dados de contato apenas se houver algo preenchido
  const contactData = [];
  if (email)       contactData.push(`E-mail: ${email}`);
  if (celular)     contactData.push(`Celular: ${celular}`);
  if (instituicao) contactData.push(`Instituição: ${instituicao}`);
  if (cargo)       contactData.push(`Cargo: ${cargo}`);

  if (contactData.length > 0) {
    lines.push('');
    lines.push('Meus dados de contato:');
    contactData.forEach(info => lines.push(`• ${info}`));
  }

  lines.push('');
  if (mensagem) {
    lines.push('*Minha mensagem:*');
    lines.push(mensagem);
  } else {
    lines.push('Desde já, agradeço a atenção e aguardo o retorno.');
  }

  return lines.join('\n');
}

// Abre o WhatsApp em nova aba/janela, com a mensagem preenchida
const goToWhatsapp = () => {
  const baseURL = whatsappURL();
  const text = getMessageText();

  // Dependendo do tipo de link, usamos ?text= ou &text=
  const param = baseURL.includes('wa.me') ? '?text=' : '&text=';
  window.open(`${baseURL}${param}${encodeURIComponent(text)}`, '_blank');
};

// Envia o formulário via fetch, usando a Google Apps Script
const submitForm = () => {
  const form = document.getElementById('contact-form');

  // 1) Verifica se o form é válido
  if (!form.checkValidity()) {
    // Se não for válido, usamos o recurso nativo do navegador para exibir o aviso
    form.reportValidity();
    return;
  }

  // 2) Evita múltiplos envios: se o form já está em "loading", não faz nada
  if (form.classList.contains('loading')) {
    return;
  }

  setLoading(true);
  const scriptURL =
    'https://script.google.com/macros/s/AKfycbwA9wsvYE6yGkpuAHu9aLYnTWACm825vU3jg-sgRUTW-fXuYJQOtSDEtobnZXFIdbk/exec';

  fetch(scriptURL, {
    method: 'POST',
    body: new FormData(form),
  })
    .then(() => {
      setSuccess();
      setLoading(false);
    })
    .catch(error => {
      const errMsg = error.message || '';
      // Se o erro for de CORS, tratamos como sucesso
      if (
        errMsg.includes("No 'Access-Control-Allow-Origin'") ||
        errMsg.includes('Failed to fetch') ||
        errMsg.includes('CORS')
      ) {
        setSuccess();
      } else {
        setError(error);
      }
      setLoading(false);
    });
};

function setLoading(loading) {
  const form = document.getElementById('contact-form');
  if (loading) {
    form.classList.add('loading');
  } else {
    form.classList.remove('loading');
  }
}

function setSuccess() {
  const form = document.getElementById('contact-form');
  form.classList.add('success');
}

function setError(error) {
  alert('Falha no envio da mensagem');
  console.error('Error!', error);
}

const Contato = () => {
  return (
    <main className="page-contact">
      <section className="contact-section">
        <div className="page-content">
          <div className="contact-container">
            <div className="contact-container-left">
              <h1 className="section-title">Dúvidas?</h1>
              <Link to="/faq" id="faq-btn" className="btn">Veja as perguntas frequentes</Link>
              <h1 className="section-title">Quer saber mais?</h1>
              <p className="section-text">Entre em contato e solicite uma demonstração.</p>
              <p className="section-text">Em poucos dias você pode ter a CODI funcionando na sua IES!</p>

              <div className="contact-info">
                <a href="mailto:faleconosco@plataformacodi.com.br">
                  📧 faleconosco@plataformacodi.com.br
                </a>
              </div>
              <div className="contact-info">
                <a href="tel:+5544991046020">
                  📞 +55 44 9 9104-6020
                </a>
              </div>
            </div>

            <div className="contact-container-right">
              <form id="contact-form" name="contact-form">
                <input
                  className="form-element form-element-field"
                  name="nome"
                  type="text"
                  placeholder="Nome"
                  required
                />
                <input
                  className="form-element form-element-field"
                  name="email"
                  type="email"
                  placeholder="Email"
                  required
                />
                <input
                  className="form-element form-element-field"
                  name="celular"
                  type="phone"
                  placeholder="Celular ou telefone"
                />
                <input
                  className="form-element form-element-field"
                  name="instituicao"
                  type="text"
                  placeholder="Instituição"
                />
                <input
                  className="form-element form-element-field"
                  name="cargo"
                  type="text"
                  placeholder="Cargo"
                />
                <textarea
                  className="form-element form-element-field"
                  name="mensagem"
                  placeholder="Mensagem"
                  required
                />
                
                {/* Botão para WhatsApp usando a função goToWhatsapp */}
                <a
                  id="whatsapp-button"
                  className="form-element btn"
                  onClick={goToWhatsapp}
                >
                  Envie um WhatsApp já!
                </a>

                <div className="or form-element">ou</div>

                {/* Botão para enviar via e-mail (Google Form) */}
                <a
                  id="email-button"
                  className="form-element btn"
                  onClick={submitForm}
                >
                  Envie um e-mail
                </a>

                {/* Mensagem de sucesso (exibida quando a classe 'success' é adicionada) */}
                <div className="form-element success">
                  Mensagem enviada!
                  <br />
                  <br />
                  Muito obrigado por entrar em contato!
                  <br />
                  Responderemos em breve.
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contato;